export const Riskidataa = [
    // Rakennetekniikka
    { id: 1, category: 'Rakennetekniikka', label: 'Kuvatusosat', risk: 'low', description: '' },
    { id: 2, category: 'Rakennetekniikka', label: 'Pihapäällysteet', risk: 'low', description: '' },
    { id: 3, category: 'Rakennetekniikka', label: 'Perustukset', risk: 'low', description: '' },
    { id: 4, category: 'Rakennetekniikka', label: 'Alapohja', risk: 'low', description: '' },
    { id: 5, category: 'Rakennetekniikka', label: 'Runkorakenteet', risk: 'low', description: '' },
    { id: 6, category: 'Rakennetekniikka', label: 'Ulkoseinät', risk: 'low', description: '' },
    { id: 7, category: 'Rakennetekniikka', label: 'Ikkunat', risk: 'low', description: '' },
    { id: 8, category: 'Rakennetekniikka', label: 'Ulko-ovet', risk: 'low', description: '' },
    { id: 9, category: 'Rakennetekniikka', label: 'Kattorakenteet', risk: 'low', description: '' },
  
    // LVI-järjestelmät
    { id: 10, category: 'LVI-järjestelmät', label: 'Lämmitysjärjestelmä', risk: 'low', description: '' },
    { id: 11, category: 'LVI-järjestelmät', label: 'Vesijohtoverkosto', risk: 'low', description: '' },
    { id: 12, category: 'LVI-järjestelmät', label: 'Viemäriverkosto', risk: 'low', description: '' },
    { id: 13, category: 'LVI-järjestelmät', label: 'Ilmanvaihtojärjestelmä', risk: 'low', description: '' },
    { id: 14, category: 'LVI-järjestelmät', label: 'Jäähdytysjärjestelmät', risk: 'low', description: '' },
    { id: 15, category: 'LVI-järjestelmät', label: 'Palontorjuntajärjestelmät', risk: 'low', description: '' },
    { id: 16, category: 'LVI-järjestelmät', label: 'Rakennusautomaatio', risk: 'low', description: '' },
  
    // Sähköjärjestelmät
    { id: 17, category: 'Sähköjärjestelmät', label: 'Sähkölaitteet', risk: 'low', description: '' },
    { id: 18, category: 'Sähköjärjestelmät', label: 'Jakelujärjestelmä', risk: 'low', description: '' },
    { id: 19, category: 'Sähköjärjestelmät', label: 'Tele- ja antennijärjestelmä', risk: 'low', description: '' },
    { id: 20, category: 'Sähköjärjestelmät', label: 'Tietoliikenne', risk: 'low', description: '' },
    { id: 21, category: 'Sähköjärjestelmät', label: 'Paloilmoitinjärjestelmä', risk: 'low', description: '' },
    { id: 22, category: 'Sähköjärjestelmät', label: 'Turvallisuusjärjestelmät', risk: 'low', description: '' },
    { id: 23, category: 'Sähköjärjestelmät', label: 'Siirtolaitteet', risk: 'low', description: '' },
  ];
  